import { CmdError, BaseError } from '@smart-tv/contexts/error-context/error-context';
import React from 'react';
import ErrorDialog from '@smart-tv/components/error-dialog/error-dialog';
import { retryButtonText } from '../error-dialog/error-dialog';

const ErrorDialogExplorePicker = ({
  error,
  reloadUniverseCategories
}: {
  error: CmdError | BaseError | undefined;
  reloadUniverseCategories: () => Promise<void>;
}) => {
  const errorDialogProps = error?.convertErrorToErrorProps({
    label: retryButtonText,
    onClick: () => reloadUniverseCategories()
  });

  return (
    error &&
    errorDialogProps && (
      <ErrorDialog
        title={errorDialogProps.title}
        message={errorDialogProps.message}
        primaryButton={errorDialogProps?.primaryButton}
      />
    )
  );
};

export default ErrorDialogExplorePicker;
